import Vue from 'vue';

const state = {
	departments: [],
	departments_loading: false
};

const getters = {
	departments: state => {
		return state.departments;
	},
	departmentsWithEmployeeCount: (state, getters, rootState, rootGetters) => {
		// Get active employees from root getter
		const employees = rootGetters['employees/employeesMiniActiveOnly'];
	
		if (!employees || employees.length === 0) {
			// Return departments with a default employee count of 0
			return state.departments.map(department => ({
				...department,
				employeeCount: 0
			}));
		}
	
		// Create a map to store department IDs and their counts
		const departmentCounts = new Map();
	
		// Iterate over employees and count by department
		employees.forEach(employee => {
			if (employee.department && employee.department.id) {
				const departmentId = employee.department.id;
				departmentCounts.set(departmentId, (departmentCounts.get(departmentId) || 0) + 1);
			}
		});
	
		// Map the counts back to state.departments with the employee count
		return state.departments.map(department => ({
			...department,
			employeeCount: departmentCounts.get(department.id) || 0
		}));
	},
	departmentOptions: state => {
		const departments = state.departments.slice(0);
		const sorted = departments.sort((a, b) => { a.name.localeCompare(b.name) });
		sorted.unshift({ id: -1, name: 'All Departments' });
		return sorted;
	}
};

const actions = {
	get({ commit, rootState }) {
		console.log('Retrieving Departments...');
		commit('GET_PENDING');
		return Vue.axios
			.get(`/api/${rootState.tenantId}/departments`)
			.then(response => {
				commit('GET_SUCCESS', response.data);
			})
			.catch(error => {
				commit('GET_FAILURE', error);
			});
	},
	add({ commit, dispatch, rootState }, department) {
		console.log('Adding New Department...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.post(`/api/${rootState.tenantId}/departments`, department)
				.then(resp => {
					commit('ADD_SUCCESS', department);
					dispatch('get');
					resolve(resp);
				})
				.catch(err => {
					console.log('Error saving Department');
					console.log(err);
					reject(err);
				});
		});
	},
	edit({ commit, dispatch, rootState }, department) {
		console.log('Updating Department...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.put(`/api/${rootState.tenantId}/departments/${department.id}`, department)
				.then(resp => {
					commit('EDIT_SUCCESS', department);
					dispatch('get');
					resolve(department);
				})
				.catch(err => {
					console.log('Error updating Department');
					console.log(err);
					reject(err);
				});
		});
	},
	delete({ commit, dispatch, rootState }, department) {
		console.log('Deleting Department...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.delete(`/api/${rootState.tenantId}/departments/${department.id}`)
				.then(resp => {
					commit('DELETE_SUCCESS', department);
					dispatch('get');
					resolve(true);
				})
				.catch(err => {
					console.log('Error deleting Department');
					console.log(err);
					reject(err);
				});
		});
	}
};

const mutations = {
	GET_PENDING(state) {
		state.departments_loading = true;
	},
	GET_SUCCESS(state, data) {
		state.departments_loading = false;
		state.departments = data;
	},
	GET_FAILURE(state, error) {
		state.departments_loading = false;
		console.log(error);
	},
	ADD_SUCCESS(state, data) {
		state.departments.push(data);
	},
	EDIT_SUCCESS(state, data) {
		let found = state.departments.find(pr => pr.id === data.id);
		if (found != null) {
			found = data;
		}
	},
	DELETE_SUCCESS(state, data) {
		const index = state.departments.indexOf(data);
		state.departments.splice(index, 1);
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
